<template>
  <div class="overflow-hidden">
    <div
      class="bg-secondary position-relative basic-type event-intro"
      id="section-event-intro"
    >
      <img
        v-if="imageVisible"
        src="@/assets/image/background wave-1.png"
        class="position-absolute"
      />
      <div
        v-if="imageVisible"
        class="wave-mask position-absolute start-0 top-0 w-100 bg-secondary"
        @animationend="animationEnd"
      ></div>
      <div
        class="content container-xl text-primary text-center lh-lg position-relative"
      >
        <TitleUnderline :title="'活動簡介'"></TitleUnderline>
        <p>
          立即報名參與零壹主題策展(Tech
          Inside)！自2022年開始，我們已成功舉辦81場主題研討會，吸引超過一萬名觀眾。我們不僅推廣解決方案與專業服務支援，更提供市場領先的加值服務，創造價值。
        </p>
        <p>
          2024年，我們將為期7周，以『無界創新、未來企業的數位日常』為題，匯聚最新IT技術，聚焦IT六大應用，並邀集前瞻專家共同探討未來企業的成功關鍵。現在就立即報名，一同加速邁向現代化企業！
        </p>
      </div>
    </div>
    <div
      class="bg-secondary basic-type feature position-relative"
      id="section-event-feature"
    >
      <div
        class="feature-content container-xl text-primary text-center position-relative"
      >
        <TitleUnderline :title="'活動特點'"></TitleUnderline>
        <div class="row">
          <div class="col-6 mb-4">
            <div
              class="bg-light feature-card rounded-4 d-flex flex-column align-items-center"
            >
              <div class="title d-flex align-items-end">
                <h3>六大應用</h3>
              </div>
              <div class="content px-2">
                <p>精選熱門產業焦點與分析，全面了解市場發展趨勢與挑戰。</p>
              </div>
            </div>
          </div>
          <div class="col-6 mb-4">
            <div
              class="bg-light feature-card rounded-4 d-flex flex-column align-items-center"
            >
              <div class="title d-flex align-items-end">
                <h3>AI虛擬主播</h3>
              </div>
              <div class="content px-2">
                <p>打破傳統範疇，開啟AI共生的新時代。</p>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="bg-light feature-card rounded-4 d-flex flex-column align-items-center"
            >
              <div class="title d-flex align-items-end">
                <h3>強強聯手</h3>
              </div>
              <div class="content px-2">
                <p>跨品牌解決方案，加速企業正確布局，邁向成功新企業。</p>
              </div>
            </div>
          </div>
          <div class="col-6">
            <div
              class="bg-light feature-card rounded-4 d-flex flex-column align-items-center"
            >
              <div class="title d-flex align-items-end">
                <h3>36場專業分享</h3>
              </div>
              <div class="content px-2">
                <p>專家分享最新的見解與成功案例，探索各領域應用。</p>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { scrollMixin } from "@/mixins/scrollMixin";

export default {
  mixins: [scrollMixin],
};
</script>

<style lang="scss">
.overflow-x-hidden {
  overflow-x: hidden;
}

.event-intro {
  z-index: 0;

  p {
    font-size: 1.5rem;
  }

  @media (max-width: $md) {
    p {
      font-size: 0.875rem;
    }
  }

  img {
    width: 110%;
    height: 140%;
    top: -15%;
    left: -5%;
    object-fit: fill;
    z-index: 1;
  }
  .wave-mask {
    height: 110%;
    animation: left-to-right 1.5s forwards;
    z-index: 2;
  }

  .content {
    z-index: 3;
  }
}
.feature {
  z-index: -1;

  .feature-content {
    z-index: 0;
  }

  .feature-card {
    height: 227px;

    .title {
      height: 60%;

      @media (max-width: $md) {
        height: 45%;
      }

      @media (max-width: 500px) {
        height: 40%;
      }
    }
    .content {
      height: 40%;

      @media (max-width: $md) {
        height: 55%;
      }

      @media (max-width: 500px) {
        height: 60%;
      }
    }

    h3 {
      font-size: 56px;
      color: transparent;
      background: linear-gradient(to right, #4653a1, #3283c2);
      -webkit-background-clip: text;
      background-clip: text;
    }

    @media (max-width: $md) {
      h3 {
        font-size: 1.25rem;
      }

      p {
        font-size: 0.875rem;
      }
    }
  }
}
</style>
